import { FC } from "react";
import { FieldFormV2, FieldV2, LoadingV2 } from "@ucl/library";
import { FIELD_KEYS } from "@/constants";
import "./OrganizationAcceptableUse.scss";
import { FinancialApplication } from "@/types/FinancialApplication";
import { useFinancialApplicationForm } from "@/hooks/useFinancialApplicationForm";
import { OrganizationAccountAcceptableUseComplexValue } from "../ComplexFields/OrganizationAccountAcceptableUseComplexField";
import {
  useFinancialApplicationFormSectionValidation,
  FinancialApplicationFormValidationDisplayBehavior,
  FinancialApplicationFormSectionContextType,
} from "@/hooks/useFinancialApplicationFormSectionValidation";
import { FinancialApplicationSection } from "@/types/enums";

export interface OrganizationAcceptableUseFormProps {
  financialApplicationId: string;
  autoValidationBehavior?: FinancialApplicationFormValidationDisplayBehavior;
  validationContextType: FinancialApplicationFormSectionContextType;
}

export const OrganizationAcceptableUseForm: FC<OrganizationAcceptableUseFormProps> = (props) => {
  const { formValue, setFormValue, saveFormData, schemaFactory, formBuilder, fieldFormModule } =
    useFinancialApplicationForm(props.financialApplicationId, props.validationContextType);

  // Get organization name from form value
  const organizationName = formValue?.organizationInformation?.legalOrganizationName;

  const { validationErrors } =
    useFinancialApplicationFormSectionValidation(
      props.financialApplicationId,
      FinancialApplicationSection.OrganizationAccountAcceptableUse,
      props.autoValidationBehavior,
      props.validationContextType
    );

  if (!schemaFactory || !formBuilder || !formValue) {
    return (
      <section className="organization-acceptable-use-form">
        <LoadingV2 />
      </section>
    );
  }

  return (
    <section className="organization-acceptable-use-form">
      <div className="organization-acceptable-use-form">
        <FieldFormV2<FinancialApplication>
          ref={fieldFormModule}
          value={formValue}
          fieldSchemaFormBuilder={formBuilder}
          onFormSubmit={async (value) => {
            await saveFormData(value);
          }}
          onFieldChanged={(newValue, newFieldValue) => {
            setFormValue(newValue, newFieldValue);
          }}
          errors={validationErrors}
        >
          <FieldV2<OrganizationAccountAcceptableUseComplexValue>
            fieldProps={FIELD_KEYS.FINANCIAL_APPLICATION.ORGANIZATION_ACCOUNT_ACCEPTABLE_USE}
            complexFieldValue={{
              showHeader: false,
              organizationName: organizationName,
            }}
          />
        </FieldFormV2>
      </div>
    </section>
  );
};
